import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-close-x",
  "use": "rt-base-close-x-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"rt-base-close-x\"><defs><style type=\"text/css\"></style></defs><path d=\"M564.3 512l262.8-312.9c4.4-5.2 0.7-13.1-6.1-13.1h-79.9c-4.7 0-9.2 2.1-12.3 5.7L512 449.8 295.3 191.7c-3-3.6-7.5-5.7-12.3-5.7h-79.9c-6.8 0-10.5 7.9-6.1 13.1L459.8 512 196.9 824.9c-4.4 5.2-0.7 13.1 6.1 13.1h79.9c4.7 0 9.2-2.1 12.3-5.7L512 574.2l216.8 258.1c3 3.6 7.5 5.7 12.3 5.7H821c6.8 0 10.5-7.9 6.1-13.1L564.3 512z\" p-id=\"2530\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/close-x.svg
// module id = 1256
// module chunks = 124